const messagesActions = {
    types: {
        MESSAGES_UPDATED: 'MESSAGES_UPDATED',
        ALL_MESSAGES_LOADED: 'ALL_MESSAGES_LOADED',
    },

    updateMessages(message) {
        return { type: this.types.MESSAGES_UPDATED, message };
    },
    allMessagesLoaded(messages) {
        return { type: this.types.ALL_MESSAGES_LOADED, messages };
    },
};

export default messagesActions;
